import { render, staticRenderFns } from "./revenue-chart.vue?vue&type=template&id=4b3339ef"
import script from "./revenue-chart.vue?vue&type=script&lang=js"
export * from "./revenue-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports